import React from "react";
import { createPortal } from "react-dom";

import "./infoPopup.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMultiply } from "@fortawesome/free-solid-svg-icons";

import { useTheme } from "../../../contexts/ThemeContext";

export default function InfoPopup({ handleClose }) {
  const { theme } = useTheme();

  return createPortal(
    <>
      <div
        className="payment-background"
        onMouseDown={(e) => e.stopPropagation()}
      />
      <div
        className="payment-container"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div
          className="close-button multi-item-mode info-mode"
          onClick={handleClose}
        >
          <FontAwesomeIcon icon={faMultiply} />
        </div>
        <div
          className={`info-box ${theme === "light" ? "info-light-mode" : ""}`}
        >
          <div className="info-text">
            <div className="info-text-pair">
              <span className="info-pair-main">آدرس :</span>
              <span>اصفهان ، مرداویج ، میدان فارابی</span>
            </div>
            <div className="info-text-pair">
              <span className="info-pair-main">تلفن :</span>
              <span>03136680995</span>
            </div>
          </div>

          <a
            referrerpolicy="origin"
            target="_blank"
            href="https://trustseal.enamad.ir/?id=300160&amp;Code=pq8sH7D4VbOOq0b2kkBW"
          >
            <img
              referrerpolicy="origin"
              src="https://Trustseal.eNamad.ir/logo.aspx?id=300160&amp;Code=pq8sH7D4VbOOq0b2kkBW"
              alt=""
              style={{ cursor: "pointer" }}
              id="pq8sH7D4VbOOq0b2kkBW"
            />
          </a>
        </div>
      </div>
    </>,
    document.getElementById("popups")
  );
}
